<ng-container [ngTemplateOutlet]="menuListTpl" [ngTemplateOutletContext]="{ menuList: menu$ | async, parentRoute: [], level: 0 }"></ng-container>

<ng-template #menuListTpl let-menuList="menuList" let-parentRoute="parentRoute" let-level="level">
  <ul navAccordion class="matero-sidemenu level-{{ level }}" [class.submenu]="level > 0">
    @for (menuItem of menuList; track menuItem; let i = $index) {
      <ng-template [ngxPermissionsOnly]="menuItem.permissions?.only" [ngxPermissionsExcept]="menuItem.permissions?.except" *appFeatureCheck="menuItem.featureName">
        <li *minRole="menuItem.allowedRole" navAccordionItem class="menu-item" [class.active]="isLinkActive(menuItem.route, parentRoute)" [route]="menuItem.route" [type]="menuItem.type">
          @if (menuItem.type === 'link' && menuItem.route === '/dashboard') {
            <a class="menu-heading" [class.activeLink]="isLinkActive('/dashboard', parentRoute)" href="/dashboard" (click)="refreshDashboardPage($event)" matRipple>
              <ng-container [ngTemplateOutlet]="linkTypeTpl" [ngTemplateOutletContext]="{ item: menuItem, level: level }"></ng-container>
            </a>
          }
          @if (menuItem.type === 'link' && isDossierMenuRoute(menuItem.route)) {
            <a class="menu-heading" [class.activeLink]="isLinkActive(menuItem.route, parentRoute)" href="/dossier/overview/projects" (click)="refreshDossierPage($event)" matRipple>
              <ng-container [ngTemplateOutlet]="linkTypeTpl" [ngTemplateOutletContext]="{ item: menuItem, level: level }"></ng-container>
            </a>
          }
          @if (menuItem.type === 'link' && menuItem.route !== '/dashboard' && !isDossierMenuRoute(menuItem.route)) {
            <a class="menu-heading" [class.activeLink]="isLinkActive(menuItem.route, parentRoute)" [routerLink]="buildRoute(parentRoute.concat([menuItem.route]))" matRipple>
              <ng-container [ngTemplateOutlet]="linkTypeTpl" [ngTemplateOutletContext]="{ item: menuItem, level: level }"></ng-container>
            </a>
          }
          @if (menuItem.type === 'extLink') {
            <a class="menu-heading" [href]="menuItem.route" matRipple>
              <ng-container [ngTemplateOutlet]="linkTypeTpl" [ngTemplateOutletContext]="{ item: menuItem, level: level }"></ng-container>
            </a>
          }
          @if (menuItem.type === 'extTabLink') {
            <a class="menu-heading" [href]="menuItem.route" target="_blank" matRipple>
              <ng-container [ngTemplateOutlet]="linkTypeTpl" [ngTemplateOutletContext]="{ item: menuItem, level: level }"></ng-container>
            </a>
          }
          @if (menuItem.type === 'sub') {
            <button navAccordionToggle class="menu-heading menu-toggle" matRipple>
              <ng-container [ngTemplateOutlet]="linkTypeTpl" [ngTemplateOutletContext]="{ item: menuItem, level: level }"></ng-container>
            </button>
          }
          <ng-container [ngTemplateOutlet]="menuListTpl" [ngTemplateOutletContext]="{ menuList: menuItem.children, parentRoute: parentRoute.concat([menuItem.route]), level: level + 1 }"></ng-container>
        </li>
      </ng-template>
    }
  </ul>
</ng-template>

<ng-template #linkTypeTpl let-item="item" let-level="level">
  @if (isCustomIcon(item)) {
    @if (level === 0) {
      <mat-icon class="menu-icon" svgIcon="{{ item.icon }}"></mat-icon>
    }
  }
  @if (!isCustomIcon(item)) {
    @if (level === 0) {
      <mat-icon class="menu-icon">{{ item.icon }}</mat-icon>
    }
  }
  <span class="menu-name">{{ item.name | translate }}</span>
  @if (item.label) {
    <span class="menu-label bg-{{ item.label.color }}">{{ item.label.value }}</span>
  }
  @if (item.badge) {
    <span class="menu-badge bg-{{ item.badge.color }}">{{ item.badge.value }}</span>
  }
  @if (item.type !== 'link') {
    <mat-icon class="menu-caret">{{ item.type === 'sub' ? 'arrow_drop_down' : 'launch' }}</mat-icon>
  }
</ng-template>
